<template>
  <div class="glass-collapse">
    <button 
      v-if="!noTrigger"
      type="button"
      class="collapse-trigger"
      :class="{ 'is-open': isOpen }"
      @click="toggle"
      :aria-expanded="isOpen"
      :aria-controls="collapseId"
    >
      <slot name="trigger">
        <span class="trigger-text">{{ title }}</span>
        <i class="fas fa-chevron-down trigger-icon"></i>
      </slot>
    </button>
    
    <transition
      name="collapse"
      @enter="onEnter"
      @after-enter="onAfterEnter"
      @leave="onLeave"
    >
      <div 
        v-show="isOpen"
        :id="collapseId"
        class="collapse-content"
        ref="content"
      >
        <div class="collapse-inner">
          <slot></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
let collapseCounter = 0;

export default {
  name: 'GlassCollapse',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    accordion: {
      type: String,
      default: ''
    },
    noTrigger: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: this.modelValue,
      collapseId: `glass-collapse-${++collapseCounter}`
    };
  },
  watch: {
    modelValue(val) {
      this.isOpen = val;
    }
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
      this.$emit('update:modelValue', this.isOpen);
      this.$emit('toggle', this.isOpen);
    },
    open() {
      this.isOpen = true;
      this.$emit('update:modelValue', true);
    },
    close() {
      this.isOpen = false;
      this.$emit('update:modelValue', false);
    },
    onEnter(el) {
      el.style.height = '0';
      el.style.overflow = 'hidden';
    },
    onAfterEnter(el) {
      el.style.height = el.scrollHeight + 'px';
      setTimeout(() => {
        el.style.height = 'auto';
        el.style.overflow = 'visible';
      }, 200);
    },
    onLeave(el) {
      el.style.height = el.scrollHeight + 'px';
      el.style.overflow = 'hidden';
      setTimeout(() => {
        el.style.height = '0';
      }, 0);
    }
  }
};
</script>

<style scoped>
.glass-collapse {
  width: 100%;
}

.collapse-trigger {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: var(--border-radius);
  color: var(--color-text);
  cursor: pointer;
  font-size: 0.9375rem;
  font-weight: 500;
  transition: all 0.2s ease;
}

.collapse-trigger:hover {
  background: rgba(255, 255, 255, 0.15);
}

.collapse-trigger.is-open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.trigger-icon {
  transition: transform 0.2s ease;
}

.collapse-trigger.is-open .trigger-icon {
  transform: rotate(180deg);
}

.collapse-content {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-top: none;
  border-bottom-left-radius: var(--border-radius);
  border-bottom-right-radius: var(--border-radius);
  transition: height 0.2s ease;
}

.collapse-inner {
  padding: 1rem;
}

/* Transition */
.collapse-enter-active,
.collapse-leave-active {
  transition: height 0.2s ease, opacity 0.2s ease;
}

.collapse-enter-from,
.collapse-leave-to {
  opacity: 0;
}
</style>
